import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiPath from '../../utils/apiPath';
import { getExpirationTime } from '../auth/auth';

/* create invitation */
export const createInvitation = createAsyncThunk('invitations/new', async (userData, { rejectWithValue }) => {
    try {
        const response = await apiPath.post('/api/v1.0/invitations/new', userData);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

/* pending invitation */
export const pendingInvitation = createAsyncThunk('invitations/pending', async (clientId, { rejectWithValue }) => {
    try {
        const response = await apiPath.get(`/api/v1.0/invitations/pending?client_id=${clientId}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

/* resend Invitation */
export const resendInvitation = createAsyncThunk('invitations/resend', async (email, { rejectWithValue }) => {
    try {
        const response = await apiPath.post('/api/v1.0/invitations/resend', {email});
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

/* accept Invitation */
export const acceptInvitation = createAsyncThunk('invitations/accept', async (userData, { rejectWithValue }) => {
    try {
        const response = await apiPath.post('/api/v1.0/invitations/accept', userData);
        localStorage.setItem("token", response.data?.data?.token);
        localStorage.setItem(
            "loginUserData",
            JSON.stringify(response.data?.data?.userData)
        );
        localStorage.setItem("tokenExpiration", getExpirationTime());
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

/* revoke Invitation */
export const revokeInvitation = createAsyncThunk('invitations/revoke', async (email, { rejectWithValue }) => {
    try {
        const response = await apiPath.post('/api/v1.0/invitations/revoke',  {email} );
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response.data);
    }
});

/* Invitation Slice @start */
const invitationSlice = createSlice({
    name: 'invitation',
    initialState: {
        loading: false,
        error: null,
        invitations:[]
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            /* create new invitation @start */
            .addCase(createInvitation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createInvitation.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.invitations.push(action.payload);
            })
            .addCase(createInvitation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            /* create new invitation @end */

            /* resend invitation @start */
            .addCase(resendInvitation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(resendInvitation.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(resendInvitation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            /* resend invitation @end */

            /* accept invitation @start */
            .addCase(acceptInvitation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(acceptInvitation.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(acceptInvitation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            /* accept invitation @end */

            /* revoke invitation @start */
            .addCase(revokeInvitation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(revokeInvitation.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                const index = state.invitations.findIndex(
                    invitation => invitation.id === action.payload.id
                );
                if (index !== -1) {
                    state.invitations[index].status = action.payload.status;
                }
            })
            .addCase(revokeInvitation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            /* revoke invitation @end */

            /* pending invitation @start */
            .addCase(pendingInvitation.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(pendingInvitation.fulfilled, (state, action) => {
                state.loading = false;
                state.error = null;
                state.invitations = action.payload.invitations || [];
            })
            .addCase(pendingInvitation.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            /* pending invitation @end */
            
    },
});
/* Invitation Slice @end */

export default invitationSlice.reducer;
